import _ from 'lodash';
import React from 'react';
import TopPanel from "../toppanel.js";
import CheckListView from "../checklists/checklistview.js";
import Modal from '../modal.js';
import TemperatureItem from './temperature_item.js';

module.exports = React.createClass({

    success: function(reply) {
        if (!this.mountState)
            return;

        this.state.isDataReceived = true;

        if (this.state.needGoBack)
            this.goBack();

        window.HC_DueCount = reply.data.length;
        HC_SetDataAndSelectedItem(this, reply.data);
    },
    loadFromServer: function() {
        HC_SendRequest("due", null, this.success, this.error);
    },
    getInitialState: function() {
        return {
            data: [],
            selectedId: null,
            goBackEnabled: false,
            changes: {},
            isDataReceived: false,
            showLinkedDocBody: false
        }
    },
    componentWillMount: function() {
        HC_CheckLoginAndAcc(this, HC_AccInput);
    },
    componentDidMount: function() {
        HC_RestoreNavPanel();
        HC_SelectNavItem("li-due");
        this.mountState = true;
        this.loadFromServer();

        HC_SubscribeHammerEvent(this.refs.due, "swiperight", this.goBack);
    },
    componentWillUnmount: function() {
        HC_UnsubscribeHammerEvent(this.refs.due, "swiperight");
        this.mountState = false;
    },
    handleOnSelected: function(e) {
        var isPhone = HC_DeviceType() == HC_CONST.SCR_PHONE;
        if (!$.isEmptyObject(this.state.changes) & this.state.selectedId == e) {
            if (isPhone) {
                this.setState({goBackEnabled: true});
                HC_SwitchRPanel();
            }
            return;
        }
        var state = {selectedId: e, changes:{}, showLinkedDocBody: false};
        if (isPhone) {
            state.goBackEnabled=true;
            this.setState(state);
            HC_SwitchRPanel();
        } else
            this.setState(state);
    },
    goBack : function() {
        HC_RestoreRPanel();
        this.setState({goBackEnabled: false});
    },
    getItemCaption: function(o) {
        return o.name;
    },
    handleOkClick: function(o) {
        this.handleSetDone(o.target.getAttribute('data-key'), true);
    },
    handleErrorClick: function(o) {
        this.handleSetDone(o.target.getAttribute('data-key'), false);
    },
    handleSetDone(id, done) {
        var changes = this.state.changes;
        if (!changes[id])
            changes[id] = {};
        changes[id].done = done;
        this.setState({changes: this.state.changes})
    },

    handleInputValue: function(id, value) {
        let changes = this.state.changes;
        if (!changes[id])
            changes[id] = {};
        changes[id].inputValue = value;
        this.setState({changes: this.state.changes})
    },
    resetChanges: function() {
        for (var key in this.state.changes) {
            if (this.state.changes[key].file && this.state.changes[key].file.path)
                HC_SendRequest('delete_file', {path: this.state.changes[key].file.path}, null, function(){});
        }
        this.setState({changes: {}});
    },
    handleSaveComment: function(itemId, text, file) {
        if (file && file.state != 'done') {
            file = null;
        }
        var changes = this.state.changes;
        if (!changes[itemId])
            changes[itemId] = {};
        changes[itemId].comment = text;
        changes[itemId].file = file;
        this.setState({changes: this.state.changes})
    },
    handleAddComment(o) {
        var checklist = HC_CurrentItem(this);
        if (!checklist)
            return;
        var itemId = o.target.getAttribute('data-key');
        var item = checklist.items.find(function(o) {return o.id == itemId;});
        if (!item)
            return;

        var commentClass = React.createClass({
            getInitialState() {
                return {
                    text: this.props.text,
                    file: this.props.file,
                    uploadError: null,
                    maxSize: 5*1024*1024,
                    saved: false
                };
            },
            componentWillUnmount: function() {
                if (!this.state.saved && this.state.file && this.state.file.path) {
                    HC_SendRequest('delete_file', {path: this.state.file.path}, null, function(){});
                }
            },
            handleSaveComment: function() {
                if (this.props.onSaveComment) {
                    this.state.saved = true;
                    this.props.onSaveComment(this.props.itemId, this.state.text, this.state.file);
                    HC_CloseModal();
                }
            },
            onTextChanged: function(o) {
                this.setState({text: o.target.value});
            },
            componentDidMount: function() {
              this.refs.comment.focus();
            },
            attachFile: function(e) {
                var input = e.target;
                if (input.files.length === 0)
                    return;
                var fileInfo = input.files[0];
                if (fileInfo.size > this.state.maxSize) {
                    this.setState({uploadError: HC_LANG.DUE_ERROR_BIG_FILE});
                    return;
                }

                this.state.uploadError = null;
                var filePath = HC_Guid();
                this.state.file = { path:filePath, state:'upload', fileInfo:fileInfo };
                var reader = new FileReader();
                reader.onload = function(){
                    var fData = new FormData();
                    fData.append("hc_file", fileInfo);
                    fData.append("hc_session_id", HC_GetSession());
                    fData.append("hc_file_id", filePath);

                    $.ajax({
                        url: HC_GetSiteAddr() + 'upload',
                        enctype: 'multipart/form-data',
                        contentType: false,
                        type: 'POST',
                        processData: false,
                        data: fData,
                        cache: false,
                        success: function (reply) {
                            if (this.state.file && this.state.file.fileInfo === fileInfo) {
                                this.state.file.state = 'done';
                                this.state.file.id = parseInt(reply);
                                this.forceUpdate();
                            }
                        }.bind(this),
                        error: function(reply) {
                            if (this.state.file && this.state.file.fileInfo === fileInfo) {
                                this.state.file.state = 'error';
                                this.state.uploadError = HC_LANG.DUE_FILE_UPLOAD_ERROR;
                                this.forceUpdate();
                            }
                        }.bind(this),
                        xhr: function()
                        {
                            var xhr = new window.XMLHttpRequest();
                            xhr.upload.addEventListener("progress", function(evt){
                                if (evt.lengthComputable) {
                                    var percentComplete = Math.round(100*evt.loaded / evt.total);
                                    $('#progress-count-' + filePath).text(percentComplete + '%');
                                }
                            }, false);
                            this.state.uploadXhr = xhr;
                            return xhr;
                        }.bind(this)
                    });
                }.bind(this);
                reader.readAsArrayBuffer(fileInfo);
                this.setState({state: 'upload'});
            },
            chooseFile: function() {
                $('#hc-due-input').click();
            },
            deleteFile: function() {
                if (this.state.file && this.state.file.path) {
                    HC_SendRequest('delete_file', {path: this.state.file.path}, null, function(){});
                }
                this.setState({file: null, uploadError: null});
            },
            render: function () {
                var attachment, error, percents;
                var file = this.state.file;
                if (!file) {
                    attachment = (<img src="public/images/ic_attachment.svg" alt="logo" width="122" height="48" onClick={this.chooseFile} style={{cursor:'pointer', float:'right', width:'50px', height:'50px', padding:'11px'}}/>);
                } else {
                    if (file.state === 'done' || file.state === 'error') {
                        var name = file.fileInfo.name, name1, name2Div;
                        if (name.length > 6) {
                            name1 = name.slice(0, -6);
                            name2Div = (<div style={{display:'inline-block', float:'left'}}>{name.slice(-6)}</div>);
                        } else {
                            name1 = name;
                        }
                        attachment = (
                            <div className={"hc-f4 " + (file.state === 'error' ? ' hc-red' : "hc-f-l")} style={{float:'right', height:'50px', padding:'11px', paddingBottom:0}}>
                                <div style={{display:'inline-block', float:'left', overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap', maxWidth:'120px'}}>{name1}</div>
                                {name2Div}
                                <i className="fa fa-times hc-delete-file" onClick={this.deleteFile} style={{padding:'5px', cursor:'pointer'}}/>
                            </div>
                        );
                    } else if (file.state === 'upload') {
                        percents = (
                            <div className={"hc-f4 hc-f-l"} style={{float:'right', height:'50px', padding:'11px'}}>
                                <span style={{marginRight:'10px'}}>Loading...</span>
                                <span id={'progress-count-' + file.path}></span>
                            </div>
                        );
                    }
                }
                if (this.state.uploadError) {
                    error = (<div className="hc-f5 hc-red">{this.state.uploadError}</div>);
                }
                var saveBtnClass = 'hc-button';
                var saveAction = this.handleSaveComment;
                if ((file && file.state !== 'done') || (!file && this.state.text.length === 0)) {
                    saveBtnClass += " hc-button-off";
                    saveAction = null;
                }
                return (
                    <Modal data-style={{maxWidth: '30rem', width: '80%'}}>
                        <div style={{margin: '5%'}}>
                            <div className="hc-f2" style={{padding: '0.5rem'}}>{HC_LANG.DUE_ADD_COMMENT}</div>
                            <div style={{padding: '0.5rem'}}>
                                <textarea ref="comment" rows="10" value={this.state.text}
                                           style={{width:'100%', height:'8rem', resize:"none"}}
                                           onChange={this.onTextChanged}/>
                                {error}
                            </div>
                            <input id="hc-due-input" type="file" className="hc-upload" accept='image/*' onChange={this.attachFile} style={{display:'none'}}/>
                            {attachment}
                            {percents}
                            <div style={{padding: '0.5rem'}}>
                                <button type='button' className={saveBtnClass} style={{marginRight:"1%"}} onClick={saveAction}>{HC_LANG.DUE_SAVE}</button>
                                <button className='hc-button-cancel hc-dialog-cancel hc-f3' onClick={HC_CloseModal}>{HC_LANG.DUE_CANCEL}</button>
                            </div>
                        </div>
                    </Modal>
                );
            }
        });
        var changesItem = this.state.changes[item.id];
        var text = changesItem && typeof changesItem.comment === 'string' ? changesItem.comment : ""
        var file = changesItem ? changesItem.file : null;
        HC_ShowModal(commentClass, {itemId: item.id, text: text, file:file, onSaveComment: this.handleSaveComment});
    },
    saveChanges: function () {
        var checklist = HC_GetItemById(this.state.data, this.state.selectedId);
        var changes = this.state.changes;
        var answers = [];
        for (var key in changes) {
            if (changes.hasOwnProperty(key)) {
                var c = changes[key];
                if (typeof c.done !== 'boolean') {
                    console.error('typeof changes[key].done != "boolean"');
                    return;
                }
                var answer = {id: parseInt(key), done: c.done ? true : false};
                if (c.comment && c.comment.length > 0)
                    answer.comment = c.comment;
                if (c.file && c.file.id)
                    answer.file = c.file.id;
                if (c.inputValue)
                    answer.input_value = parseFloat(c.inputValue);
                answers.push(answer);
            }
        }

        if (answers.length !== checklist.items.length) {
            console.error("answers.length !== checklist.items.length");
            return;
        }

        HC_SendRequest('edit_due', {id: checklist.id, items: answers}, this.success);
        this.state.data = this.state.data.filter(function(o){return o.id != checklist.id});
        this.state.isDataReceived = false;
        checklist.sent = true;
        this.setState({changes:{}, data:this.state.data});
        this.goBack();
    },

    discloseDoc: function() {
        let currentDocState = this.state.showLinkedDocBody;
        this.setState({showLinkedDocBody: !currentDocState});
    },

    render: function() {
        var header;
        var checklist = HC_CurrentItem(this);
        if (!checklist) {
            checklist = {items: []};
            header = HC_LANG.CHL_EMPTY;
        } else {
            header = checklist.name;
        }


        var licon = this.state.goBackEnabled ? "fa-angle-left" : "";

        var changes = this.state.changes;
        var changesKeys = Object.keys(changes).filter(function(o){return changes.hasOwnProperty(o)});
        var hasChanges = changesKeys.length > 0;
        var allDone = changesKeys.length === checklist.items.length && changesKeys.filter(function(o){return typeof changes[o].done !== 'boolean'}).length === 0;

        var tdStyle = {textAlign: "center", width:'60px', cursor:'pointer', borderTop:'none'};
        let dueItemControl, isChecklistTypeRegular = checklist.checklist_type == 0;
        var rows = checklist.items.map(function(o) {
            let icon = changes[o.id] && (changes[o.id].comment && changes[o.id].comment.length > 0 || changes[o.id].file) ? "fa-comment fa hc-fa-medium hc-fa-action" : "fa-comment-o fa hc-fa-medium hc-fa-action";
            if (isChecklistTypeRegular)
                return (
                    <tr key={o.id} style={{borderTop:"0 !important", height:"60px"}}>
                        <td key="1" data-key={o.id} className={"hc-due-check" + (changes[o.id] && changes[o.id].done === true ? "-active" : "")} style={tdStyle} onClick={this.handleOkClick}>
                            <div data-key={o.id}><i data-key={o.id} className="fa hc-fa-medium fa-check"></i></div>
                        </td>
                        <td key="2" data-key={o.id} className={"hc-due-error" + (changes[o.id] && changes[o.id].done === false ? "-active" : "")} style={tdStyle} onClick={this.handleErrorClick}>
                            <div data-key={o.id}><i data-key={o.id} className="fa hc-fa-medium fa-close "></i></div>
                        </td>

                        <td key="3" style={{borderTop: "0 !important", position:'relative'}}>
                            <div style={{display:'block', whiteSpace: "nowrap", width:'100%', overflow:"hidden"}}>{o.item}</div>
                            <div style={{display:'block', whiteSpace: "nowrap", width:'100%', overflow:"hidden"}}>{o.action}</div>
                            <div style={{display:'inline-block', position:'absolute', top:0, right:0, height:'100%', width: '30px', float:'right', backgroundImage: 'linear-gradient(to left, #ffffff, rgba(255, 255, 255, 0.9) 52%, rgba(255, 255, 255, 0.0))'}}></div>
                        </td>
                        <td key="4" className="hc-hover" style={tdStyle} data-key={o.id} onClick={this.handleAddComment}><i className={icon} data-key={o.id}/></td>
                    </tr>
                );
            else
                return (<TemperatureItem key={o.id} item={o} changesItem={changes[o.id]} handleInputValue={this.handleInputValue} handleApplyItem={this.handleOkClick}/>)
        }.bind(this));

        if (isChecklistTypeRegular) {
            dueItemControl = (
                <table className="table table-bordered hc-table hc-f3" style={{width: "100%", tableLayout: 'fixed'}}>
                    <tbody>
                    {rows}
                    </tbody>
                </table>);
        }
        else
            dueItemControl = <div>{rows}</div>;

        let savePanel;
        if (!checklist.sent && (hasChanges || (checklist.id && checklist.items.length === 0))) {
            savePanel = (<div style={{textAlign:"center", margin:'15px auto'}}>
                <button type='button' className={'hc-button' + (allDone ? '' : ' hc-button-off')}
                        onClick={allDone ? this.saveChanges : null}>{HC_LANG.DUE_SAVE}</button>
                <label type='button' className='hc-dialog-cancel hc-f3' onClick={this.resetChanges}
                       style={{marginLeft:"1rem", verticalAlign:"sub"}}>{HC_LANG.DUE_CANCEL}</label>
            </div>);
        } else {
            savePanel = (<div></div>);
        }

        let linked_document;
        if (checklist.linked_document) {
            let linkedDocBody =
                <div className="hc-f4 hc-f" style={{ margin: "20px", whiteSpace: "pre-wrap"}}>
                    {checklist.linked_document.content}
                </div>;
            let attachedFiles =
                <div className="linked-doc-files hc-f4 hc-f" style={{ margin: "20px" }}>
                    {_.map(checklist.linked_document.files, a => {
                        return <div key={a.id} className="doc-attachment hc-fa-action" style={{ marginTop: "5px", cursor: "pointer" }}
                                    onClick={() => HC_DownloadFile(a.path, a.name)} >{a.name}</div>;
                    })}
                </div>;
            linked_document =
                <div style={{marginTop: "1rem"}}>
                    <div className="hc-ba hc-file-link hc-flex-display" style={{display:"flex", height:'58px', margin:'auto', overflow:'hidden'}} onClick={this.discloseDoc}>
                        <div className="fa hc-f1 fa-file-text-o hc-green"  style={{display:"inline-block", margin:"auto", padding:"15px", flex:"0 0 50px"}}></div>
                        <div className="hc-f3" style={{display:"inline-block", position:'relative', margin:'auto', marginLeft: "0", flex:"0 0 auto", width: "CALC(100% - 100px)",  overflow:'hidden'}}>
                            <div style={{display:"inline-block", whiteSpace:'nowrap', textOverflow:'ellipsis', width:'100%', overflow:'hidden', verticalAlign:'middle'}}>
                                {checklist.linked_document.title}
                            </div>
                        </div>
                    </div>
                    {this.state.showLinkedDocBody && linkedDocBody}
                    {this.state.showLinkedDocBody && attachedFiles}
                </div>
        }

        return (
            <div id="panel-Due" style={{height:"100%"}}>
                <div className="hc-list-panel hc-br">
                    <TopPanel text={HC_LANG.NAV_DUE} licon="fa-bars" onLiconClick={HC_ToggleNavPanel}
                              showProgress={this.state.noData}/>
                    <div>
                        <CheckListView data={this.state.data} isEmpty={this.state.isDataReceived && this.state.data.length === 0} getCaption={this.getItemCaption} getText={HC_GetChecklistText} selectedId={this.state.selectedId} onSelect={this.handleOnSelected}
                                       showOnly = {true}/>
                    </div>
                </div>
                <div className="hc-content-panel">
                    <div className="hc-internal-panel">
                        <TopPanel text={header} licon={licon} onLiconClick={this.goBack}/>
                        <div ref="due" style={{position:"absolute", left:"-1px", top:'60px', right:0, bottom:0, overflowY: "auto", WebkitOverflowScrolling:'touch'}}>
                            {dueItemControl}
                            {linked_document}
                            {savePanel}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
});



// WEBPACK FOOTER //
// ./dues/due.js